module.exports = __webpack_public_path__ + "static/media/opensourceparrot.ced8f741.gif";